import * as React from "react"
import { IconButton } from "@chakra-ui/react"
import { CircleCloseIconProps } from "./types"
import { IoClose } from "react-icons/io5"

const _CircleCloseIcon: React.FC<CircleCloseIconProps> = props => {
  return (
    <IconButton
      icon={<IoClose />}
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="24px"
      height="24px"
      minH="24px"
      minW="24px"
      position="relative"
      background="black"
      color="white"
      borderRadius="50%"
      cursor="pointer"
      fontSize="1rem"
      zIndex={1000000}
      {...props}
    />
  )
}

export const CircleCloseIcon = React.memo(_CircleCloseIcon)
